import { Link, useLocation } from "react-router";
import { MESSAGE_ID_PARAM } from "../../constants/messages";
import { createElement } from "react";
import IconSigneringDone from "../../components/icons/IconSigneringDone";

const SigneringDone = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const messageId = queryParams.get("messageId");
  const erklaeringId = queryParams.get("erklaeringId");
  const erklaeringIndsendes = queryParams.get("erklaeringIndsendes");
  const signingUser = queryParams.get("signingUser");
  const message = MESSAGE_ID_PARAM[parseInt(messageId ?? "0")];
  const messageHtml = createElement("div", {
    className: "fw-medium col-12 col-lg-7 mx-auto mt-5",
    dangerouslySetInnerHTML: { __html: message },
  });

  return (
    <div className="container-xxl pt-7 text-center">
      <div className="mb-5 text-success">
        <IconSigneringDone height={70} />
      </div>
      <h1 className="display-1 fw-bold">Godkendt af {signingUser}</h1>
      {messageHtml}
      <div className="mt-5">
        {erklaeringIndsendes?.toLocaleLowerCase() === "true" ? (
          <Link
            to={"/login"}
            style={{ border: "none" }}
            className="link-primary fs-4 text-decoration-underline"
          >
            Tilbage til forsiden
          </Link>
        ) : (
          <Link
            to={`/klientkontoerklaering/${erklaeringId}`}
            style={{ border: "none" }}
            className="link-primary fs-4 text-decoration-underline"
          >
            Tilbage til erklæringen
          </Link>
        )}
      </div>
    </div>
  );
};

export default SigneringDone;
